import type { MindMapDocument } from '@/model/document';
import type { MapSnapshot } from '@/model/types';

/**
 * Serialize the full map document to a JSON string.
 */
export function exportJson(mapDoc: MindMapDocument): string {
  const nodes = mapDoc.getAllNodes();
  const connections = mapDoc.getAllConnections();
  const meta = mapDoc.getMeta();
  const settings = mapDoc.getSettings();

  const snapshot: MapSnapshot = {
    meta,
    settings,
    nodes: Object.fromEntries(nodes),
    connections: Object.fromEntries(connections),
  };

  return JSON.stringify(snapshot, null, 2);
}
